var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DefaultCheckbox',{attrs:{"value":_vm.checkboxValue},on:{"input":(val) => _vm.$emit('changeProductChecked', val)}})
}
var staticRenderFns = []

export { render, staticRenderFns }